import { useState } from "react";
import { Button, Card, DataList, PageHeader, StatusBadge, type DataColumn } from "@nahal/ui";
import type { AuditEvent } from "@nahal/api-client";
import { useAudit } from "../../lib/queries";

export function AuditScreen() {
  const [page, setPage] = useState(0);
  const audit = useAudit(page);

  const columns: Array<DataColumn<AuditEvent>> = [
    { key: "action", header: "Action", primary: true, cell: (row) => row.action },
    { key: "actor", header: "Actor", cell: (row) => row.actorLabel ?? row.actorType },
    {
      key: "when",
      header: "When",
      cell: (row) => new Date(row.createdAt).toLocaleString(),
    },
    { key: "summary", header: "Summary", desktopOnly: true, cell: (row) => row.summary ?? "-" },
    {
      key: "request",
      header: "Request id",
      desktopOnly: true,
      cell: (row) => (
        <code className="text-2xs text-[var(--text-muted)]">{row.requestId ?? "-"}</code>
      ),
    },
  ];

  const total = audit.data?.totalPages ?? 1;

  return (
    <>
      <PageHeader
        title="Audit"
        description="Every platform write, with the request id that ties it to a log line."
        meta={<StatusBadge status={`page ${page + 1} of ${Math.max(total, 1)}`} tone="neutral" />}
      />

      <Card>
        <DataList
          columns={columns}
          rows={audit.data?.items ?? []}
          rowKey={(row) => row.id}
          loading={audit.isLoading}
          error={audit.isError ? "Could not load the audit trail." : null}
          empty={{ title: "Nothing recorded yet" }}
        />
      </Card>

      <div className="mt-3 flex items-center justify-between gap-2">
        <Button variant="outline" disabled={page === 0} onClick={() => setPage((p) => p - 1)}>
          Previous
        </Button>
        <Button
          variant="outline"
          disabled={page + 1 >= total}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </Button>
      </div>
    </>
  );
}
